import { AppBar, Tab, Tabs } from "@material-ui/core";
import React from "react";
import { style } from "./style";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import queryString, { stringify } from "query-string";
import sha256 from "sha256";
import CryptoJS from "crypto-js";

import Loading from "../loading";
import Snackbar from "../snackbar";
import Header from "../../partials/header";
import { VNPayConfig, ZaloPayConfig } from "../../utils/setting";
import PaymentHisttory from "./paymentHistory";
import AccountBalance from "./accountBalance";
import AddPayment from "./addPayment";
class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      isAddPayment: false,
    };
  }
  async componentDidMount() {
    const { t } = this.props;
    // Redirect from zalopay server
    if (this.props.history.location.search) {
      let zaloPayParams = queryString.parse(this.props.history.location.search);
      let checksumData =
        zaloPayParams.appid +
        "|" +
        zaloPayParams.apptransid +
        "|" +
        zaloPayParams.pmcid +
        "|" +
        zaloPayParams.bankcode +
        "|" +
        zaloPayParams.amount +
        "|" +
        zaloPayParams.discountamount +
        "|" +
        zaloPayParams.status;
      let checksum = CryptoJS.HmacSHA256(
        checksumData,
        ZaloPayConfig.key2
      ).toString();
      if (checksum === zaloPayParams.checksum) {
        let checkStatus = await this.props.getStatusByApptransid({
          apptransid: zaloPayParams.apptransid,
        });
        if (checkStatus.code === 1) {
          let data = {
            receiveMoney: Number(zaloPayParams.amount),
            note: "note",
          };
          await this.props.addBalanceForOwner(data);
          this.mSnackbar &&
            this.mSnackbar.handleClick(t("payment_add_balance_successfully"));
          this.props.history.push("/service/payment");
        } else {
          this.mSnackbar &&
            this.mSnackbar.handleClick(
              t("payment_add_balance_unsuccessfully"),
              "error"
            );
        }
      } else {
        this.mSnackbar &&
          this.mSnackbar.handleClick(
            t("payment_add_balance_unsuccessfully"),
            "error"
          );
      }
    }

    // //  Payment VNPAY
    // if (this.props.history.location.search) {
    //   let vnPayParams = queryString.parse(this.props.history.location.search);
    //   let secureHash = vnPayParams["vnp_SecureHash"];
    //   delete vnPayParams["vnp_SecureHash"];
    //   delete vnPayParams["vnp_SecureHashType"];
    //   // vnPayParams = sortObject(vnPayParams);
    //   let signData =
    //     VNPayConfig.vnp_HashSecret + stringify(vnPayParams, { encode: false });
    //   let checkSum = sha256(signData);
    //   if (secureHash === checkSum) {
    //     //Kiem tra xem du lieu trong db co hop le hay khong va thong bao ket qua
    //     let data = {
    //       receiveMoney: Number(vnPayParams["vnp_Amount"]) / 100,
    //       note: vnPayParams["vnp_OrderInfo"],
    //     };
    //     await this.props.addBalanceForOwner(data);
    //     this.mSnackbar &&
    //       this.mSnackbar.handleClick(t("payment_add_balance_successfully"));
    //     this.props.history.push("/service/payment");
    //   } else {
    //     this.mSnackbar &&
    //       this.mSnackbar.handleClick(
    //         t("payment_add_balance_unsuccessfully"),
    //         "error"
    //       );
    //   }
    // }
  }
  handleChangeTab = (event, value) => {
    this.setState({ tab: value });
  };
  addPayment = () => {
    // this.AccountBalance.addPayment()
    let isAddPayment = this.state.isAddPayment;
    this.setState({ isAddPayment: !isAddPayment });
  };
  render() {
    const { tab, isAddPayment } = this.state;
    const { t, classes, ipAddress, ...props } = this.props;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        {/* Header  */}
        {isAddPayment && (
          <Header
            session={t("service_ownerspa_createservice_payment")}
            title={t("service_account_add_payment")}
            backIcon={true}
            actionBack={this.addPayment}
          />
        )}
        {!isAddPayment && tab === 0 && (
          <Header
            session={t("sidebar_manage")}
            title={t("service_ownerspa_createservice_payment")}
            button={t("payment_add_payment")}
            actionButton={this.addPayment}
          />
        )}
        {!isAddPayment && tab === 1 && (
          <Header
            session={t("sidebar_manage")}
            title={t("service_ownerspa_createservice_payment")}
          />
        )}

        {/* Body */}
        {isAddPayment && <AddPayment onRef={(id) => (this.AddPayment = id)} />}
        {!isAddPayment && (
          <React.Fragment>
            <AppBar
              position="static"
              color="default"
              className={classes.appTabs}
            >
              <Tabs
                value={tab}
                onChange={this.handleChangeTab}
                indicatorColor="secondary"
                textColor="primary"
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabsIndicator,
                  fixed: classes.tabsFixed,
                }}
                scrollButtons="on"
                variant="scrollable"
              >
                <Tab
                  label={t(
                    "service_ownerspa_createservice_payment_account_balance"
                  )}
                  classes={{
                    root: classes.tabRoot,
                    textColorPrimary: classes.textColorPrimary,
                    selected: classes.selected,
                  }}
                />
                <Tab
                  label={t(
                    "service_ownerspa_createservice_payment_payment_history"
                  )}
                  classes={{
                    root: classes.tabRoot,
                    textColorPrimary: classes.textColorPrimary,
                    selected: classes.selected,
                  }}
                />
              </Tabs>
            </AppBar>
            {tab === 0 && (
              <AccountBalance
                onRef={(id) => (this.AccountBalance = id)}
                {...props}
              />
            )}
            {tab === 1 && <PaymentHisttory {...props} />}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  adminService: state.service.adminService,
  total: state.auditBalance.total,
  ipAddress: state.setting.ipAddress,
});

const mapDispatch = (dispatch) => ({
  getHistory: dispatch.auditBalance.getHistory,
  addBalanceForOwner: dispatch.serviceAccount.addBalanceForOwner,
  getStatusByApptransid: dispatch.serviceAccount.getStatusByApptransid,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: true })(Payment)));
